/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import "./index.css";

import React, { useRef } from "react";
import { ReactComponent as DraggableBlockMenuIcon } from "../../images/icons/draggable-block-menu.svg";
import { DraggableBlockPlugin_EXPERIMENTAL } from "../LexicalDraggableBlockPlugin";

const ADD_BUTTON_CLASSNAME = "add-block-menu";
const DRAGGABLE_BLOCK_MENU_CLASSNAME = "draggable-block-menu";

function isOnMenu(element: HTMLElement): boolean {
  const isOnMenu = !!element.closest(`.${ADD_BUTTON_CLASSNAME}`) || !!element.closest(`.${DRAGGABLE_BLOCK_MENU_CLASSNAME}`);
  return isOnMenu;
}

export default function DraggableBlockPlugin({ anchorElem = document.body }: { anchorElem?: HTMLElement }): JSX.Element {
  const menuRef = useRef<HTMLDivElement>(null);
  const targetLineRef = useRef<HTMLDivElement>(null);

  return (
    <DraggableBlockPlugin_EXPERIMENTAL
      anchorElem={anchorElem}
      menuRef={menuRef}
      targetLineRef={targetLineRef}
      menuComponent={
        <div ref={menuRef} className="icon draggable-block-menu">
          <DraggableBlockMenuIcon />
        </div>
      }
      targetLineComponent={<div ref={targetLineRef} className="draggable-block-target-line" />}
      isOnMenu={isOnMenu}
    />
  );
}
